import Link from "next/link";
import { ButtonProps } from "@/types";
import { cn } from "@/lib/utils";

export default function Button({
  href,
  variant = "outline",
  size = "md",
  icon,
  iconColor = "white",
  outlineColor = "white",
  className,
  children,
  ...props
}: ButtonProps) {
  const baseStyles =
    "group inline-flex items-center justify-center font-poppins font-normal text-base transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-green disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none";

  const variants = {
    outline: `border ${outlineColor === "green" ? "border-brand-green" : "border-white"} text-white`,
    solid: "bg-brand-green text-white",
  };

  const sizes = {
    sm: "px-4 py-1.5 text-sm gap-1.5",
    md: "px-6 py-2 text-base gap-2.5",
    lg: "px-8 py-3 text-lg gap-3",
  };

  const combinedClasses = cn(
    baseStyles,
    variants[variant],
    sizes[size],
    className
  );

  const iconElement = icon ? (
    <span
      className={cn(
        "inline-flex shrink-0 transition-transform duration-500 ease-in-out group-hover:rotate-[90deg]",
        iconColor === "green" ? "text-brand-green" : "text-white"
      )}
    >
      {icon}
    </span>
  ) : null;

  if (href) {
    return (
      <Link href={href} className={combinedClasses}>
        <span>{children}</span>
        {iconElement}
      </Link>
    );
  }

  return (
    <button className={combinedClasses} {...props}>
      <span>{children}</span>
      {iconElement}
    </button>
  );
}
